import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faBars
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Drawer from "@material-ui/core/Drawer";
import React, { useState } from "react";
import MenuStyle from "../styles/MenuStyle";

interface MenuProps {
  children: any;
  width?: number;
  appName?: string;
  permanent: boolean;
  handlePermanent: Function;
}

const Menu = (props: MenuProps) => {
  const { children, appName, permanent, handlePermanent } = props;

  const [isExpanded, setIsExpanded] = useState(true);

  const childrenWithProps = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      closeDrawer: () => !permanent && setIsExpanded(false),
      openedDrawer: isExpanded
    })
  );

  const getIcon = () => {
    if (permanent) return faBars as IconProp;
    if (isExpanded) return faAngleDoubleLeft as IconProp;
    return faAngleDoubleRight as IconProp;
  };

  return (
    <MenuStyle open={isExpanded}>
      <Drawer
        className="drawer"
        variant="permanent"
        anchor="left"
        open={isExpanded}
        onClose={() => setIsExpanded(false)}
        onMouseEnter={() => !permanent && setIsExpanded(true)}
        onMouseLeave={() => !permanent && setIsExpanded(false)}
      >
        <div
          tabIndex={-1}
          role="button"
          className={isExpanded ? "open-drawer" : "close-drawer"}
        >
          <div
            className="icon-drawer--variant"
            onClick={() => handlePermanent && handlePermanent()}
          >
            {isExpanded && <p className="headerLogo">{appName}</p>}
            <button className="faBtn">
              <FontAwesomeIcon className="fa-icon" icon={getIcon()} />
            </button>
          </div>
          {childrenWithProps}
        </div>
      </Drawer>
    </MenuStyle>
  );
};

export default Menu;
